import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const HtmlTooltip = ({ children, content }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const containerRef = useRef(null);

    const handleMouseEnter = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        setTooltipPosition({
            x: rect.right + scrollLeft + 5,
            y: rect.top + scrollTop + rect.height / 2
        });
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <>
            <div
                ref={containerRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{ position: 'relative', display: 'inline-block' }}
            >
                {children}
            </div>
            {showTooltip && ReactDOM.createPortal(
                <div
                    className="html-tooltip"
                    style={{
                        position: 'absolute',
                        top: `${tooltipPosition.y}px`,
                        left: `${tooltipPosition.x}px`,
                        transform: 'translateY(-50%)',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        color: 'white',
                        padding: '12px 16px',
                        borderRadius: '6px',
                        fontSize: '11px',
                        zIndex: 99999,
                        maxWidth: '320px',
                        minWidth: '200px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                        pointerEvents: 'none',
                        border: '1px solid rgba(255,255,255,0.1)'
                    }}
                    dangerouslySetInnerHTML={{ __html: content }}
                />,
                document.body
            )}
        </>
    );
};

HtmlTooltip.propTypes = {
    children: PropTypes.node.isRequired,
    content: PropTypes.string.isRequired,
};

export default HtmlTooltip;
